import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "../i18n";

const KEY = "cristalda_cookie_consent";

export const hasConsent = () => localStorage.getItem(KEY) === "accepted";

export const CookieConsent = () => {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-40 p-4 sm:p-5"
    >
      <div className="mx-auto max-w-4xl rounded-2xl border border-slate-200 bg-white/95 backdrop-blur shadow-[0_12px_40px_rgba(0,32,64,0.18)] p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <span className="h-10 w-10 shrink-0 rounded-full bg-primary/8 text-primary flex items-center justify-center">
            <Cookie className="h-5 w-5" />
          </span>
          <p className="text-sm text-slate-600 leading-relaxed">
            {t("cookie.msg")}{" "}
            <Link to="/legale/cookie" className="font-semibold text-primary underline underline-offset-2" data-testid="cookie-policy-link">
              {t("cookie.more")}
            </Link>
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            type="button"
            onClick={() => decide("essential")}
            data-testid="cookie-reject-btn"
            className="rounded-full border border-slate-200 px-5 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50 transition-colors"
          >
            {t("cookie.essential")}
          </button>
          <button
            type="button"
            onClick={() => decide("accepted")}
            data-testid="cookie-accept-btn"
            className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary/90 transition-colors"
          >
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
